
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinar/uk-application-week",
      function () {
        return require("private-next-pages/webinar/uk-application-week.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinar/uk-application-week"])
      });
    }
  